module.exports = __webpack_public_path__ + "img/menuminilotto.e402ddb6.png";